// src/pages/ChatPage.js
import React, {
  useState,
  useRef,
  useEffect,
  useContext,
  useMemo,
  useCallback,
} from "react";
import aiService from "../services/aiService";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/ChatPage.css";
import "../styles/PlacePopover.css";
import { ConcordThinking } from "../_components/main/AIThinkingMessage";
import "bootstrap-icons/font/bootstrap-icons.css";
import { ActivitiesContext } from "../context/ActivitiesContext";
import { fetchActivities as generateItinerary } from "../_utils/api";
import { changeActivity, replaceActivity } from "../_utils/api";
import requestBody from "../data/mockBody";
import { OverlayTrigger, Popover } from "react-bootstrap";
import "leaflet/dist/leaflet.css";
import ReactMarkdown from "react-markdown";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/MyTripComponent.css";
import AdvancedAnimatedMap from "../_components/main/AdvancedAnimatedMap";
import PlaceDetailModal from "../_components/main/PlaceDetailModal";
import ExploreComponent from "../_components/main/ExploreComponent";
import MyTripComponent from "../_components/main/MyTripComponent";
import SavedComponent from "../_components/main/SavedComponent";
import RecommendationPanel from "../_components/main/RecommendationPanel/RecommendationPanel";
import { ChatFlowManager } from "../_utils/chatFlowManager";
import TravelPreferenceModal from "../_components/main/TravelPreferenceModal";
import {
  AI_RESPONSE_TYPES,
  CONVERSATION_STAGES,
} from "../constants/chatConstants";

import { useSmartPlanning } from "../hooks/useSmartPlanning";

//活动弹窗

const ChatAvatars = {
  ai: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <circle cx="9" cy="9" r="2" />
      <circle cx="15" cy="9" r="2" />
      <path d="M9 15h6" stroke="currentColor" strokeWidth="2" fill="none" />
    </svg>
  ),
  user: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <circle cx="12" cy="8" r="4" />
      <path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" />
    </svg>
  ),
};

const PlacePopover = React.forwardRef(
  ({ placeId, title, activityData, ...props }, ref) => {
    // console.log(
    //   "🏷️ PlacePopover rendering for:",
    //   title,
    //   "with activityData:",
    //   activityData
    // );

    return (
      <Popover
        ref={ref}
        id={`popover-${placeId}`}
        className="modern-popover"
        {...props}
      >
        <Popover.Header
          as="h6"
          className="modern-popover-header d-flex align-items-center"
        >
          <span className="modern-popover-icon">📍</span>
          {title}
        </Popover.Header>
        <Popover.Body className="modern-popover-body">
          <div>
            {activityData ? (
              <>
                {/* 地点图片 */}
                {activityData.image_url && (
                  <div className="mb-3">
                    <img
                      src={activityData.image_url}
                      alt={title}
                      className="place-image"
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                  </div>
                )}

                {/* 活动时间 */}
                {activityData.time && (
                  <div className="mb-3 d-flex align-items-center time-section">
                    <span className="info-icon">⏰</span>
                    <strong className="time-text">{activityData.time}</strong>
                  </div>
                )}

                {/* 活动描述 */}
                {activityData.description && (
                  <div className="mb-3 description-section">
                    <span className="description-text">
                      {activityData.description}
                    </span>
                  </div>
                )}

                {/* 活动名称（如果与title不同） */}
                {activityData.name && activityData.name !== title && (
                  <div className="info-item">
                    <span className="info-icon">🏷️</span>
                    <span className="info-text-green">{activityData.name}</span>
                  </div>
                )}

                {/* 地点信息（如果与title不同） */}
                {activityData.location && activityData.location !== title && (
                  <div className="info-item">
                    <span className="info-icon">📌</span>
                    <span className="info-text-orange">
                      {activityData.location}
                    </span>
                  </div>
                )}

                {/* 预估花费时间 */}
                {activityData.duration && (
                  <div className="info-item">
                    <span className="info-icon">⏳</span>
                    <span className="info-text-gray">
                      Duration: {activityData.duration}
                    </span>
                  </div>
                )}

                {/* 底部标签区域 */}
                <div className="tags-section">
                  {/* 费用信息 */}
                  {activityData.cost && (
                    <span className="tag-cost">💰 ${activityData.cost}</span>
                  )}

                  {/* 价格等级 */}
                  {activityData.price_level && (
                    <span className="tag-price">
                      {"$".repeat(activityData.price_level)}
                    </span>
                  )}

                  {/* 菜系类型 */}
                  {activityData.cuisine && (
                    <span className="tag-cuisine">
                      🍽️ {activityData.cuisine}
                    </span>
                  )}

                  {/* 活动类型/分类 */}
                  {activityData.type && (
                    <span className="tag-type">{activityData.type}</span>
                  )}
                </div>

                {/* 网站链接 */}
                {activityData.website && (
                  <div className="mt-3">
                    <a
                      href={activityData.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="website-link"
                    >
                      🔗 Visit Website
                    </a>
                  </div>
                )}

                {/* 特殊备注 */}
                {activityData.notes && (
                  <div className="notes-section">
                    <span className="notes-text">💡 {activityData.notes}</span>
                  </div>
                )}

                {/* 地址信息 */}
                {activityData.address &&
                  activityData.address !== activityData.location && (
                    <div className="address-section">
                      <small className="address-text">
                        🏠 {activityData.address}
                      </small>
                    </div>
                  )}
              </>
            ) : (
              // 如果没有活动数据，显示基本信息
              <div className="empty-state">
                <div className="empty-state-icon">📍</div>
                <span className="empty-state-text">
                  Activity location in your itinerary
                </span>
              </div>
            )}

            {/* 开发环境下的调试信息 */}
            {process.env.NODE_ENV === "development" && (
              <div className="debug-section">
                <small className="debug-info">
                  <strong>Debug Info:</strong>
                  <br />
                  Place ID: {placeId}
                  <br />
                  Has Activity Data: {activityData ? "Yes" : "No"}
                  <br />
                  Has Image: {activityData?.image_url ? "Yes" : "No"}
                  <br />
                  {activityData && (
                    <>
                      Available Fields: {Object.keys(activityData).join(", ")}
                    </>
                  )}
                </small>
              </div>
            )}
          </div>
        </Popover.Body>
      </Popover>
    );
  }
);

const ChatPage = () => {
  const location = useLocation();
  //ipad 移动端检测
const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [deviceType, setDeviceType] = useState(() => {
    const width = window.innerWidth;
    if (width <= 768) return "mobile";
    if (width <= 1366) return "tablet";
    return "desktop";
  });
const [rightPanelOpen, setRightPanelOpen] = useState(false);
const [startX, setStartX] = useState(0);
const [currentX, setCurrentX] = useState(0);
const [isDragging, setIsDragging] = useState(false);
const needsSwipePanel = window.innerWidth <= 1366; // iPad 及以下


  const flowManager = new ChatFlowManager();
  const navigate = useNavigate();
  const [userChoices, setUserChoices] = useState({});
  const isMountedRef = useRef(true);
  const abortControllerRef = useRef(null);
  const [mapExpanded, setMapExpanded] = useState(false);
  const [selectedTier, setSelectedTier] = useState("Basic");
  const [itinerary, setItinerary] = useState([]);
  //点击渲染地名时
  const [selectedPlaceForModal, setSelectedPlaceForModal] = useState(null);
  const [showPlaceModal, setShowPlaceModal] = useState(false);
  //explore
  const [currentView, setCurrentView] = useState("chat"); // 'chat' | 'explore'
  const [selectedExploreLocations, setSelectedExploreLocations] = useState([]);
  //mytrip
  const [favorites, setFavorites] = useState([]); // 收藏的地点ID列表
  const [myTripItems, setMyTripItems] = useState([]); // 我的行程项目
  const [allRecommendations, setAllRecommendations] = useState([]);
  //thinking
  const [isAIThinking, setIsAIThinking] = useState(false);
  const [thinkingStage, setThinkingStage] = useState("typing");
  //chatHistory
  const [chatHistory, setChatHistory] = useState([]);
  const [currentChatId, setCurrentChatId] = useState(null);
  const [showChatHistory, setShowChatHistory] = useState(false);
  // 🆕 添加智能规划相关状态
  const { processRequest, checkIfContainsDateInfo, isProcessing } =
    useSmartPlanning();
  const [isSmartPlanActive, setIsSmartPlanActive] = useState(false);

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isGeneratingItinerary, setIsGeneratingItinerary] = useState(false);

  // 🆕 添加旅行偏好相关状态
  const [showPreferenceModal, setShowPreferenceModal] = useState(false);
  const [travelPreferences, setTravelPreferences] = useState(null);
  const [preferenceFlowStarted, setPreferenceFlowStarted] = useState(false);
  const [hasSetPreferences, setHasSetPreferences] = useState(false);

  const hasProcessedInitialMessage = useRef(false);

  const [isIPad, setIsIPad] = useState(false);

  // 第 134 行后添加
  const getDeviceInfo = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const isLandscape = width > height;

    // iPad Air 11" 横屏约为 1366x1024
    const isIPadLandscape = isLandscape && width >= 1024 && width <= 1400;

    return {
      isMobile: width <= 768,
      isTablet: width > 768 && width <= 1400,
      isIPadLandscape,
      isDesktop: width > 1400,
    };
  };

  const [deviceInfo, setDeviceInfo] = useState(getDeviceInfo());

  useEffect(() => {
    const handleResize = () => {
      setDeviceInfo(getDeviceInfo());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const checkIsIPad = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isIPadUA =
        /ipad/.test(userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
      const isTabletSize =
        window.innerWidth >= 1024 && window.innerWidth <= 1366;

      setIsIPad(isIPadUA || isTabletSize);
    };

    checkIsIPad();
    window.addEventListener("resize", checkIsIPad);
    return () => window.removeEventListener("resize", checkIsIPad);
  }, []);

  // 在组件初始化时自动折叠侧边栏
  useEffect(() => {
    if (deviceType === "tablet" && !sidebarCollapsed) {
      setSidebarCollapsed(true);
    }
  }, [deviceType]);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 768) setDeviceType("mobile");
      else if (width <= 1366) setDeviceType("tablet");
      else setDeviceType("desktop");
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 移动端检测

  const [showMobileMap, setShowMobileMap] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 移动端地图切换
  const handleMobileMapToggle = () => {
    setShowMobileMap(!showMobileMap);
  };

  const [lastGeneratedItineraryHash, setLastGeneratedItineraryHash] =
    useState(null);
  const [isGeneratingText, setIsGeneratingText] = useState(false);
  // 处理侧边栏折叠的函数
  const handleSidebarToggle = () => {
    setSidebarCollapsed(!sidebarCollapsed);
    // 保存用户偏好到本地存储
    localStorage.setItem("sidebar_collapsed", !sidebarCollapsed);
  };
  const [ExpectingModification, setExpectingModification] = useState(false);
  const [candidates, setCandidates] = useState([]);
  const [pendingReplacement, setPendingReplacement] = useState(null);

  // 🆕 处理快速开始（使用默认偏好）
  const handleQuickStart = () => {
    const defaultPreferences = {
      sightseeing: 25,
      nature: 25,
      culture: 20,
      Restaurant: 20,
      entertainment: 10,
    };
    setTravelPreferences(defaultPreferences);
    setHasSetPreferences(true); // 🆕 标记已设置偏好
    startPreferenceFlow(defaultPreferences);
  };

  // 🆕 处理偏好确认
  const handlePreferenceConfirm = (preferences) => {
    setTravelPreferences(preferences);
    setShowPreferenceModal(false);
    setHasSetPreferences(true); // 🆕 标记已设置偏好

    // 添加用户选择的偏好到聊天记录
    appendBlock({
      type: "chat",
      who: "user",
      text: `I've set my preferences: ${Object.entries(preferences)
        .map(([key, value]) => `${key}: ${value}%`)
        .join(", ")}`,
    });

    startPreferenceFlow(preferences);
  };

  // 🆕 开始偏好流程
  const startPreferenceFlow = (preferences) => {
    setPreferenceFlowStarted(true);
    setHasSetPreferences(true);

    // 只清除 preference-prompt 类型的块，保留所有聊天消息
    setBlocks((prev) =>
      prev.filter((block) => block.type !== "preference-prompt")
    );

    // 检查是否有待处理的导航状态
    const pendingState = sessionStorage.getItem("pendingNavigationState");
    if (pendingState) {
      const locationState = JSON.parse(pendingState);
      sessionStorage.removeItem("pendingNavigationState");

      // 添加确认消息
      appendBlock({
        type: "chat",
        who: "ai",
        text: `Perfect! I've noted your preferences: ${Object.entries(
          preferences
        )
          .map(
            ([key, value]) =>
              `${key.charAt(0).toUpperCase() + key.slice(1)}: ${value}%`
          )
          .join(
            ", "
          )}.\n\nNow let me create your 5-day Montreal itinerary with a day trip to Quebec City, with options from basic to luxury budget...`,
      });

      // 🆕 不要调用 handleMainPageInput，而是直接处理请求
      setIsAIThinking(true);
      setThinkingStage("processing");

      // 使用原始消息和偏好来生成行程
      processRequest(locationState.initialMessage, {
        currentPage: "chatPage",
        hasExistingItinerary: false,
        fromMainPage: true,
        travelPreferences: preferences, // 🆕 传递偏好
      })
        .then((result) => {
          setIsAIThinking(false);

          if (result.success) {
            // 不要清空 blocks，保持对话连续性
            setItinerary(result.itinerary);
            changeAllActivities(result.itinerary);

            appendBlock({
              type: "chat",
              who: "ai",
              text: result.message,
            });

            // 生成行程文本和按钮
            setTimeout(async () => {
              const textGenerated = await generateItineraryTextOnce(
                result.itinerary,
                "startPreferenceFlow"
              );

              if (textGenerated) {
                setTimeout(() => {
                  appendBlock({
                    type: "dual-buttons",
                    buttons: [
                      {
                        label: " Print PDF",
                        onClick: handlePrintPDF,
                        className: "btn-success",
                      },
                      {
                        label: " Add to My Trip",
                        onClick: () =>
                          handleAddItineraryToMyTripDirect(result.itinerary),
                        className: "btn-info",
                      },
                      {
                        label: " Modify Itinerary",
                        onClick: handleModifyItinerary,
                        className: "btn-primary",
                      },
                    ],
                  });
                }, 500);
              }
            }, 1000);

            extractLocationsWithCoordinates(result.itinerary).then(
              setChatLocations
            );
            setMapExpanded(true);
            setIsSmartPlanActive(true);
          } else {
            appendBlock({
              type: "chat",
              who: "ai",
              text: result.message || "抱歉，我无法根据您提供的信息生成行程。",
            });
          }
        })
        .catch((error) => {
          setIsAIThinking(false);
          console.error("Smart planning error:", error);
          appendBlock({
            type: "chat",
            who: "ai",
            text: "处理您的请求时遇到错误，让我用其他方式帮助您。",
          });
        });

      return;
    }

    // 如果没有待处理的状态，继续正常流程
    appendBlock({
      type: "chat",
      who: "ai",
      text: `Perfect! I'll customize your Montreal itinerary based on your preferences. Now let's continue with a few more details.\n\nWhat type of activities excite you most?`,
    });

    appendBlock({
      type: "preference",
      stage: "activity",
      options: ["Adventure", "Nature", "City Strolls", "Cultural Immersion"],
    });
  };

  const handlePlaceClick = (activityData, placeName) => {
    console.log("🏢 Place clicked:", placeName, activityData);
    setSelectedPlaceForModal({ data: activityData, name: placeName });
    setShowPlaceModal(true);
  };
  // 处理探索位置选择
  const handleExploreLocationSelect = (location) => {
    setSelectedExploreLocations((prev) => {
      const isAlreadySelected = prev.some((loc) => loc.id === location.id);
      if (isAlreadySelected) {
        return prev.filter((loc) => loc.id !== location.id);
      } else {
        return [...prev, location];
      }
    });
  };
  const generateChatId = () => {
    return `chat_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  };

  // 🔄 替换现有的 saveCurrentChat 函数
  const saveCurrentChat = () => {
    if (blocks.length > 1 && currentChatId) {
      const chatTitle = generateChatTitle();
      const chatData = {
        id: currentChatId,
        title: chatTitle,
        blocks: [...blocks],
        userChoices: { ...userChoices },
        itinerary: [...itinerary],
        timestamp: new Date().toISOString(),
        lastMessage: getLastUserMessage(),
      };

      setChatHistory((prev) => {
        const existingIndex = prev.findIndex(
          (chat) => chat.id === currentChatId
        );
        if (existingIndex !== -1) {
          // 更新现有聊天
          const updated = [...prev];
          updated[existingIndex] = chatData;
          return updated;
        } else {
          // 添加新聊天
          return [chatData, ...prev].slice(0, 20); // 最多保存20个聊天
        }
      });
    }
  };

  const handleSmartPlanResult = async (smartPlanResult, initialMessage) => {
    if (isGeneratingItinerary) {
      console.log("🚫 Already generating, skip...");
      return;
    }
    setIsGeneratingItinerary(true);
    setBlocks([]);

    appendBlock({
      type: "chat",
      who: "user",
      text: initialMessage,
    });

    if (smartPlanResult.success) {
      setItinerary(smartPlanResult.itinerary);
      changeAllActivities(smartPlanResult.itinerary);

      appendBlock({
        type: "chat",
        who: "ai",
        text: smartPlanResult.message,
      });

      setTimeout(async () => {
        const textGenerated = await generateItineraryTextOnce(
          smartPlanResult.itinerary,
          "handleSmartPlanResult"
        );

        if (textGenerated) {
          // 只在文本生成成功后才添加按钮
          setTimeout(() => {
            appendBlock({
              type: "dual-buttons",
              buttons: [
                {
                  label: " Print PDF",
                  onClick: handlePrintPDF,
                  className: "btn-success",
                },
                {
                  label: " Add to My Trip",
                  onClick: () =>
                    handleAddItineraryToMyTripDirect(smartPlanResult.itinerary),
                  className: "btn-info",
                },
                {
                  label: " Modify Itinerary",
                  onClick: handleModifyItinerary,
                  className: "btn-primary",
                },
              ],
            });
          }, 500);
        }
      }, 1000);
      setIsGeneratingItinerary(false);

      extractLocationsWithCoordinates(smartPlanResult.itinerary).then(
        setChatLocations
      );
      setMapExpanded(true);
      setIsSmartPlanActive(true);
    }
  };

  const handleInitialMessage = (initialMessage, errorMessage) => {
    appendBlock({
      type: "chat",
      who: "user",
      text: initialMessage,
    });

    if (errorMessage) {
      appendBlock({
        type: "chat",
        who: "ai",
        text: errorMessage,
      });
    }
  };
  // 🆕 生成聊天标题
  const generateChatTitle = () => {
    const userMessages = blocks.filter((block) => block.who === "user");
    if (userMessages.length > 0) {
      const firstMessage = userMessages[0].text;
      return firstMessage.length > 30
        ? firstMessage.substring(0, 30) + "..."
        : firstMessage;
    }

    // 根据用户选择生成标题
    if (userChoices.activity || userChoices.cuisine || userChoices.tier) {
      const parts = [];
      if (userChoices.activity) parts.push(userChoices.activity);
      if (userChoices.cuisine) parts.push(userChoices.cuisine);
      if (userChoices.tier) parts.push(userChoices.tier);
      return `Montreal ${parts.join(" + ")} Trip`;
    }

    return `Montreal Trip - ${new Date().toLocaleDateString()}`;
  };

  // 🆕 获取最后一条用户消息
  const getLastUserMessage = () => {
    const userMessages = blocks.filter((block) => block.who === "user");
    return userMessages.length > 0
      ? userMessages[userMessages.length - 1].text
      : "";
  };

  const handleNewChat = () => {
    console.log("🚀 Starting new chat");

    // 保存当前聊天（如果有内容）
    if (blocks.length > 1) {
      saveCurrentChat();
    }

    // 🔥 修改：更通用的欢迎消息，不再固定5天4晚
    setBlocks([
      {
        type: "chat",
        who: "ai",
        text: "Bonjour! 🍁 Welcome to City Getaways! I'm your AI travel assistant here to help you plan an amazing Montreal adventure.\n\nYou can:\n• Tell me specific dates (e.g., '3 days in Montreal')\n• Choose your preferences step by step\n• Ask me anything about Montreal\n\nWhat would you like to do?",
      },
    ]);

    // 重置用户选择和其他状态
    setUserChoices({});
    setItinerary([]);
    setChatLocations([]);
    setSelectedTier("Basic");
    setInputText("");
    setIsAIThinking(false);
    setMapExpanded(false);
    setIsSmartPlanActive(false); // 🔥 添加：重置智能规划状态

    // 生成新的聊天 ID
    const newChatId = generateChatId();
    setCurrentChatId(newChatId);

    // 切换到聊天视图
    setCurrentView("chat");

    // 显示成功提示
    console.log("✅ New chat started with ID:", newChatId);
  };

  const handleLoadChat = (chatData) => {
    console.log("📂 Loading chat:", chatData.title);

    // 保存当前聊天
    if (blocks.length > 1 && currentChatId && currentChatId !== chatData.id) {
      saveCurrentChat();
    }

    // 加载选中的聊天
    setBlocks(chatData.blocks || []);
    setUserChoices(chatData.userChoices || {});
    setItinerary(chatData.itinerary || []);
    setCurrentChatId(chatData.id);

    // 重置其他状态
    setInputText("");
    setIsAIThinking(false);
    setCurrentView("chat");
    setShowChatHistory(false);

    console.log("✅ Chat loaded successfully");
  };

  // 🆕 删除聊天历史
  const handleDeleteChat = (chatId, event) => {
    event.stopPropagation(); // 防止触发加载聊天

    setChatHistory((prev) => prev.filter((chat) => chat.id !== chatId));

    // 如果删除的是当前聊天，开始新聊天
    if (chatId === currentChatId) {
      handleNewChat();
    }
  };

  // 🆕 初始化：设置初始聊天 ID
  useEffect(() => {
    if (!currentChatId) {
      setCurrentChatId(generateChatId());
    }
  }, []);

  // 获取当前对话阶段的改进版本
  const getCurrentStage = () => {
    // 如果已经生成了行程
    if (itinerary && itinerary.length > 0) {
      return CONVERSATION_STAGES.CUSTOM;
    }

    // 根据用户选择判断阶段
    if (userChoices.tier) {
      return CONVERSATION_STAGES.COMPLETE;
    } else if (userChoices.cuisine) {
      return CONVERSATION_STAGES.TIER;
    } else if (userChoices.activity) {
      return CONVERSATION_STAGES.CUISINE;
    } else {
      return CONVERSATION_STAGES.ACTIVITY;
    }
  };

  // 处理侧边栏菜单点击
  const handleMenuClick = (menuType) => {
    console.log("🎯 Menu clicked:", menuType);

    setCurrentView(menuType);

    if (menuType === "explore" || menuType === "mytrip") {
      setMapExpanded(true); // 这些模式下展开地图
    } else if (menuType === "chat") {
      // 聊天模式可以选择保持或重置地图状态
    }
  };

  // 处理添加到收藏
  const handleAddToFavorites = (location) => {
    console.log("💖 Adding to favorites:", location);

    setFavorites((prev) => {
      const isAlreadyFavorited = prev.includes(location.id);
      if (isAlreadyFavorited) {
        // 取消收藏
        return prev.filter((id) => id !== location.id);
      } else {
        // 添加到收藏
        return [...prev, location.id];
      }
    });

    // 确保推荐数据也被保存到 allRecommendations 中
    setAllRecommendations((prev) => {
      const exists = prev.some((item) => item.id === location.id);
      if (!exists) {
        return [...prev, location];
      }
      return prev;
    });
  };
  const handleRemoveFromFavorites = (location) => {
    console.log("💔 Removing from favorites:", location);
    setFavorites((prev) => prev.filter((id) => id !== location.id));
  };

  const handleAddToMyTrip = (location) => {
    console.log("➕ Adding to my trip:", location);
    console.log("📊 Current myTripItems before adding:", myTripItems);

    setMyTripItems((prev) => {
      // 检查是否已经在行程中
      const isAlreadyInTrip = prev.some((item) => item.id === location.id);
      if (isAlreadyInTrip) {
        console.log("⚠️ Item already in trip");
        return prev;
      }

      // 添加到行程，包含必要的数据
      const tripItem = {
        ...location,
        id: location.id || Date.now().toString(), // 确保有ID
        addedAt: new Date().toISOString(),
        plannedDate: null, // 用户稍后可以设置
        plannedTime: null,
        plannedEndTime: null,
        notes: "",
        // 确保有必要的字段用于预算计算
        cost: location.cost || location.avg_cost_per_person || 0,
        category: location.category || location.type || "Activity",
        image: location.image || location.image_url,
        description: location.description || "",
        website: location.website || location.url,
      };

      console.log("✅ Adding trip item:", tripItem);
      const newTripItems = [...prev, tripItem];
      console.log("📊 New myTripItems after adding:", newTripItems);

      return newTripItems;
    });
  };

  // 处理从我的行程移除
  const handleRemoveFromMyTrip = (itemId) => {
    console.log("🗑️ Removing from my trip:", itemId);

    setMyTripItems((prev) => prev.filter((item) => item.id !== itemId));

    // 这里可以调用 API 从服务器删除
    // removeFromMyTripAPI(itemId);
  };

  // 处理更新行程项目
  const handleUpdateTripItem = (itemId, updates) => {
    console.log("📝 Updating trip item:", itemId, updates);

    setMyTripItems((prev) =>
      prev.map((item) => (item.id === itemId ? { ...item, ...updates } : item))
    );

    // 这里可以调用 API 更新服务器数据
    // updateMyTripItemAPI(itemId, updates);
  };

  const getFavoriteLocations = () => {
    return allRecommendations.filter((item) => favorites.includes(item.id));
  };
  // 获取当前要在地图上显示的位置
  // 在 ChatPage.js 的 getMapLocations 函数中添加：
  const getMapLocations = () => {
    let locations;
    switch (currentView) {
      case "explore":
        locations = selectedExploreLocations.filter(
          (loc) => typeof loc.lat === "number" && typeof loc.lng === "number"
        );
        break;
      case "mytrip":
        locations = myTripItems.filter(
          (loc) => typeof loc.lat === "number" && typeof loc.lng === "number"
        );
        break;
      case "saved":
        locations = getFavoriteLocations().filter(
          (loc) => typeof loc.lat === "number" && typeof loc.lng === "number"
        );
        break;
      default: // chat
        locations = chatLocations.filter(
          (loc) => typeof loc.lat === "number" && typeof loc.lng === "number"
        );
        break;
    }

    // 🆕 增强调试
    console.log("🗺️ getMapLocations 调试：");
    console.log("  - currentView:", currentView);
    console.log("  - chatLocations:", chatLocations);
    console.log("  - chatLocations.length:", chatLocations.length);
    console.log("  - 返回的 locations:", locations);
    console.log("  - 返回的 locations.length:", locations.length);

    return locations;
  };

  // 关闭模态框
  const handleCloseModal = () => {
    setShowPlaceModal(false);
    setSelectedPlaceForModal(null);
  };
  useEffect(() => {
    window.scrollTo(150, 150);
    isMountedRef.current = true;

    // 组件卸载时的清理函数
    return () => {
      isMountedRef.current = false;
      // 取消所有进行中的异步操作
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const handleModifyItinerary = () => {
    console.log("Modify Itinerary button clicked!");

    // 在跳转前清理地图相关状态
    setMapExpanded(false);
    setChatLocations([]);

    // 添加短暂延迟确保清理完成
    setTimeout(() => {
      if (isMountedRef.current) {
        navigate("/budget-tiers", {
          state: { selectedTier },
        });
      }
    }, 100);
  };

  //从收藏添加到我的行程
  const handleAddFromSavedToTrip = (location) => {
    console.log("➕ Adding from saved to my trip:", location);
    handleAddToMyTrip(location);
  };

  const handleAddItineraryToMyTripDirect = (itineraryData) => {
    console.log("➕ Adding itinerary directly:", itineraryData);

    if (!itineraryData || itineraryData.length === 0) {
      console.log("❌ No itinerary data provided");
      return;
    }

    const tripItems = [];

    itineraryData.forEach((day, dayIndex) => {
      const activities = day.plan || [];

      activities.forEach((activity, actIndex) => {
        const tripItem = {
          id: `itinerary-${dayIndex}-${actIndex}-${Date.now()}`,
          name:
            activity.location ||
            activity.activity ||
            `Activity ${actIndex + 1}`,
          location: activity.location || "Montreal, Canada",
          // image: activity.image_url || "https://via.placeholder.com/150",
          description: activity.activity_desc || "No description",
          cost: activity.avg_cost_per_person || 0,
          category: activity.cuisine ? "Restaurant" : "Activity",
          addedAt: new Date().toISOString(),
          plannedDate: null,
          plannedTime: activity.start_time || null,
          // 🔑 关键：添加天数信息
          dayNumber: dayIndex + 1, // Day 1, Day 2, etc.
          fromItinerary: true, // 标记来自行程
          originalDayIndex: dayIndex,
          fullData: activity,
        };
        tripItems.push(tripItem);
      });
    });

    setMyTripItems((prev) => [...prev, ...tripItems]);

    appendBlock({
      type: "chat",
      who: "ai",
      text: `✅ Successfully added ${tripItems.length} activities to your trip!`,
    });
  };

  const { planId, startDate, endDate, changeAllActivities } =
    useContext(ActivitiesContext);
  // We will store an ordered list of "blocks": either chat bubbles or option sets.
  const [blocks, setBlocks] = useState(() => {
    // 检查是否有来自其他页面的导航
    if (location.state?.initialMessage) {
      return []; // 初始为空，让 useEffect 处理
    }

    // 否则显示默认欢迎消息
    return [
      {
        type: "chat",
        who: "ai",
        text: "Bonjour! 🍁 Welcome to City Getaways! I'm your AI travel assistant here to help you plan an amazing Montreal adventure.\n\nBefore we begin, I'd like to understand your travel style better. Would you like to customize your trip preferences?",
      },
      {
        type: "preference-prompt",
        buttons: [
          {
            label: " Customize Preferences",
            onClick: () => setShowPreferenceModal(true),
            className: "btn-primary",
          },
          {
            label: " Quick Start",
            onClick: () => handleQuickStart(),
            className: "btn-secondary",
          },
        ],
      },
    ];
  });

  // Free‐text input at the bottom
  const [inputText, setInputText] = useState("");
  const [chatLocations, setChatLocations] = useState([]);
  const validLocations = chatLocations.filter(
    (loc) => typeof loc.lat === "number" && typeof loc.lng === "number"
  );
  // A ref to scroll to bottom on every update
  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    scrollToBottom();
  }, [blocks]);

  useEffect(() => {
    const locationState = location.state;

    if (locationState?.initialMessage && !hasSetPreferences) {
      // 🆕 检查是否已经添加过这条消息
      const messageExists = blocks.some(
        (block) =>
          block.type === "chat" &&
          block.who === "user" &&
          block.text === locationState.initialMessage
      );

      if (!messageExists) {
        // 设置所有需要的 blocks，而不是逐个 append
        setBlocks([
          {
            type: "chat",
            who: "user",
            text: locationState.initialMessage,
          },
          {
            type: "chat",
            who: "ai",
            text: "Great question! Before I create your Montreal itinerary with options from basic to luxury, I'd like to understand your travel preferences better. This will help me customize the perfect trip for you.",
          },
          {
            type: "preference-prompt",
            buttons: [
              {
                label: " Customize Preferences",
                onClick: () => setShowPreferenceModal(true),
                className: "btn-primary",
              },
              {
                label: " Use Default Preferences",
                onClick: () => handleQuickStart(),
                className: "btn-secondary",
              },
            ],
          },
        ]);

        // 保存状态以便偏好设置后处理
        sessionStorage.setItem(
          "pendingNavigationState",
          JSON.stringify(locationState)
        );
      }
    }
  }, [location.state?.initialMessage, hasSetPreferences]);

  const handleMainPageInput = async (userInput) => {
    console.log("🎯 Handling MainPage input:", userInput);

    // 重置聊天状态
    setBlocks([]);
    setUserChoices({});
    setItinerary([]);
    setChatLocations([]);

    // 添加用户消息
    appendBlock({
      type: "chat",
      who: "user",
      text: userInput,
    });

    // 首先检查是否包含日期/天数信息
    if (checkIfContainsDateInfo(userInput)) {
      console.log("🎯 Detected date/day planning request from MainPage");
      setIsAIThinking(true);
      setThinkingStage("processing");

      try {
        const result = await processRequest(userInput, {
          currentPage: "chatPage",
          hasExistingItinerary: false,
          fromMainPage: true,
          travelPreferences,
        });

        setIsAIThinking(false);

        if (result.success) {
          console.log("🎯 Smart planning SUCCESS - Full result:", result);
          console.log("🗺️ result.itinerary:", result.itinerary);
          console.log("🗺️ result.itinerary type:", typeof result.itinerary);
          console.log(
            "🗺️ result.itinerary is array:",
            Array.isArray(result.itinerary)
          );
          console.log("🗺️ result.itinerary length:", result.itinerary?.length);

          // 检查数据结构
          if (result.itinerary && result.itinerary.length > 0) {
            console.log("🗺️ First day data:", result.itinerary[0]);
            console.log("🗺️ First day plan:", result.itinerary[0]?.plan);
          }

          // 成功生成智能规划
          setItinerary(result.itinerary);
          changeAllActivities(result.itinerary);

          // 🔥 添加防重复检查
          if (
            !window.lastAIMessage ||
            window.lastAIMessage !== result.message
          ) {
            appendBlock({
              type: "chat",
              who: "ai",
              text: result.message,
            });
            window.lastAIMessage = result.message;
          }

          setTimeout(async () => {
            const textGenerated = await generateItineraryTextOnce(
              result.itinerary,
              "handleMainPageInput"
            );

            if (textGenerated) {
              setTimeout(() => {
                appendBlock({
                  type: "dual-buttons",
                  buttons: [
                    {
                      label: " Print PDF",
                      onClick: handlePrintPDF,
                      className: "btn-success",
                    },
                    {
                      label: " Add to My Trip",
                      onClick: () =>
                        handleAddItineraryToMyTripDirect(result.itinerary),
                      className: "btn-info",
                    },
                    {
                      label: " Modify Itinerary",
                      onClick: handleModifyItinerary,
                      className: "btn-primary",
                    },
                  ],
                });
              }, 500);
            }
          }, 1000);

          // 更新地图
          extractLocationsWithCoordinates(result.itinerary).then(
            setChatLocations
          );
          setMapExpanded(true);
          setIsSmartPlanActive(true);
          return; // 🚨 重要：这里return，避免继续执行
        } else {
          // 智能规划失败，显示失败消息
          appendBlock({
            type: "chat",
            who: "ai",
            text: result.message || "抱歉，我无法根据您提供的信息生成行程。",
          });

          if (result.suggestions) {
            setTimeout(() => {
              appendBlock({
                type: "preference",
                stage: "suggestions",
                options: result.suggestions,
              });
            }, 1000);
          }
        }
      } catch (error) {
        setIsAIThinking(false);
        console.error("Smart planning error:", error);
        appendBlock({
          type: "chat",
          who: "ai",
          text: "处理您的请求时遇到错误，让我用其他方式帮助您。",
        });
      }

      return; // 🚨 重要：智能规划处理完后直接返回
    }

    // 如果不包含日期信息，使用 AI 聊天
    setIsAIThinking(true);
    setThinkingStage("thinking");

    try {
      const response = await aiService.sendMessage(userInput, {
        userChoices: {},
        currentStage: "INITIAL",
        hasItinerary: false,
        fromMainPage: true,
      });

      setIsAIThinking(false);
      handleAIResponse(response);
    } catch (error) {
      setIsAIThinking(false);
      appendBlock({
        type: "chat",
        who: "ai",
        text: "I understand you're looking to plan a trip! Let me help you get started. What type of experience are you most interested in?",
      });

      setTimeout(() => {
        appendBlock({
          type: "preference",
          stage: "activity",
          options: [
            "Adventure",
            "Nature",
            "City Strolls",
            "Cultural Immersion",
          ],
        });
      }, 1000);
    }
  };

  const nameToActivityData = useMemo(() => {
    const map = {};

    console.log("🔄 Building nameToActivityData from itinerary:", itinerary);

    if (!itinerary || !Array.isArray(itinerary)) {
      console.log("❌ No valid itinerary data");
      return map;
    }

    itinerary.forEach((day, dayIndex) => {
      console.log(`📅 Processing day ${dayIndex + 1}:`, day);

      // 检查不同可能的活动数组字段名
      const activities = day.plan || day.activities || day.events || [];

      if (Array.isArray(activities)) {
        activities.forEach((activity, actIndex) => {
          console.log(`  📍 Processing activity ${actIndex + 1}:`, activity);
          console.log(`    - Available fields:`, Object.keys(activity || {}));

          if (!activity) return;

          // 根据实际数据结构，使用正确的字段名
          const possibleNames = [
            activity.location, // 地点名称
            activity.activity, // 活动名称
            activity.itinerary_name, // 行程名称
          ].filter((name) => name && typeof name === "string" && name.trim());

          console.log(`    - Possible names:`, possibleNames);

          possibleNames.forEach((name) => {
            const cleanName = name.trim();
            if (cleanName && !map[cleanName]) {
              // 避免重复，使用第一个遇到的
              map[cleanName] = {
                // 保存所有原始数据
                ...activity,
                // 根据实际字段结构标准化
                displayName: cleanName,
                place_id: activity.place_id,
                time:
                  activity.start_time && activity.end_time
                    ? `${activity.start_time} - ${activity.end_time}`
                    : activity.start_time || activity.end_time,
                description: activity.activity_desc || activity.description,
                location: activity.location,
                name: activity.activity || activity.itinerary_name,
                cost: activity.avg_cost_per_person
                  ? `${activity.avg_cost_per_person}`
                  : null,
                cuisine: activity.cuisine,
                price_level: activity.price_level,
                image_url: activity.image_url,
                website: activity.url,
              };
              console.log(
                `    ✅ Added mapping: "${cleanName}" ->`,
                map[cleanName]
              );
            }
          });
        });
      }
    });

    console.log("🗺️ Final nameToActivityData mapping:", map);
    console.log("🏷️ Available place names for popover:", Object.keys(map));
    return map;
  }, [itinerary]);

  const nameToPlaceId = useMemo(() => {
    const map = {};
    if (itinerary && itinerary.length > 0) {
      itinerary.forEach((day) => {
        if (day && day.plan) {
          day.plan.forEach((act) => {
            const name = act.location || act.name;
            if (name && act.place_id) {
              // 同时映射原始名称和可能的变体
              map[name] = act.place_id;
              map[name.trim()] = act.place_id;
              // 处理可能的大小写问题
              map[name.toLowerCase()] = act.place_id;
            }
          });
        }
      });
    }
    console.log("nameToPlaceId mapping:", map); // 调试用
    return map;
  }, [itinerary]);

  // Utility to append either a chat block or an options block
  const appendBlock = (newBlock) => {
    setBlocks((prev) => [...prev, newBlock]);
  };

  // Handler when a user clicks ANY of the option buttons
  const handleOptionClick = async (stage, choice) => {
    // Add user's choice as a chat message
    appendBlock({ type: "chat", who: "user", text: choice });

    // Update user choices
    setUserChoices((prev) => ({
      ...prev,
      [stage]: choice,
    }));

    // Handle custom suggestions from AI
    if (stage === "suggestions") {
      appendBlock({
        type: "chat",
        who: "ai",
        text: "🤔 Processing...",
        isLoading: true,
      });

      try {
        const response = await aiService.sendMessage(choice, {
          userChoices,
          isFromSuggestion: true,
          currentStage: getCurrentStage(),
        });

        setBlocks((prev) => prev.filter((block) => !block.isLoading));
        console.log("715 resonse", response);
        handleAIResponse(response);
      } catch (error) {
        setBlocks((prev) => prev.filter((block) => !block.isLoading));
        appendBlock({
          type: "chat",
          who: "ai",
          text: "😔 Sorry, something went wrong. Please try again.",
        });
      }
      return;
    }

    // Handle preset flow stages
    if (stage === "activity") {
      // AI-enhanced response for activity choice
      const activityResponses = {
        Adventure:
          "Excellent choice! 🎯 Montreal has thrilling adventures waiting for you. From zip-lining at Parc Jean-Drapeau to white-water rafting on the Lachine Rapids!",
        Nature:
          "Beautiful! 🌳 You'll love Montreal's green spaces - from the majestic Mount Royal Park to the stunning Botanical Gardens.",
        "City Strolls":
          "Perfect! 🚶‍♂️ Montreal's neighborhoods are made for wandering - from historic Old Montreal to trendy Mile End.",
        "Cultural Immersion":
          "Wonderful! 🎭 Montreal's rich culture awaits - museums, festivals, and historic sites will fill your days.",
      };

      appendBlock({
        type: "chat",
        who: "ai",
        text:
          activityResponses[choice] ||
          `Great choice with ${choice}! Now, let's talk about food - what cuisine excites your taste buds? 🍽️`,
      });

      appendBlock({
        type: "preference",
        stage: "cuisine",
        options: ["French", "Italian", "Local Specialties", "Asian Fusion"],
      });
    } else if (stage === "cuisine") {
      // AI-enhanced response for cuisine choice
      const cuisineResponses = {
        French:
          "Magnifique! 🥐 Montreal's French heritage shines through its bistros and patisseries. You'll enjoy authentic French cuisine with a Quebec twist!",
        Italian:
          "Bellissimo! 🍝 Little Italy awaits with authentic trattorias and the best espresso outside of Rome!",
        "Local Specialties":
          "Fantastic! 🍁 Get ready for poutine, smoked meat, and bagels - Montreal's culinary icons!",
        "Asian Fusion":
          "Exciting choice! 🥢 Montreal's diverse Asian fusion scene offers innovative flavors from across the continent!",
      };

      appendBlock({
        type: "chat",
        who: "ai",
        text:
          cuisineResponses[choice] ||
          `Thanks! You prefer "${choice}" cuisine. Finally, what's your budget comfort level? 💰`,
      });

      appendBlock({
        type: "preference",
        stage: "tier",
        options: ["Basic", "Signature", "Luxury"],
      });
    } else if (stage === "tier") {
      setSelectedTier(choice);

      // AI-enhanced response for tier choice
      const tierResponses = {
        Basic:
          "Smart choice! 💵 I'll craft an amazing Montreal experience that's easy on the wallet but rich in memories!",
        Signature:
          "Perfect balance! 💎 You'll enjoy Montreal's best experiences with great value - the sweet spot of comfort and adventure!",
        Luxury:
          "Excellent! 🥂 Get ready for Montreal's finest - from 5-star hotels to Michelin-starred dining experiences!",
      };

      appendBlock({
        type: "chat",
        who: "ai",
        text:
          tierResponses[choice] ||
          "Great! Let me create your personalized itinerary... 🚀",
      });

      // Show loading message
      appendBlock({
        type: "chat",
        who: "ai",
        text: "Crafting your perfect Montreal adventure... This might take a moment! ⏳",
      });

      // Prepare request body
      const body = {
        ...requestBody,
        plan_id: planId,
        start_date: startDate.toISOString().slice(0, 10),
        end_date: endDate.toISOString().slice(0, 10),
        arrival_time: userChoices.start_time || "08:00 AM",
        preferences: {
          activity_type: userChoices.activity,
          cuisine_preference: userChoices.cuisine,
          budget_tier: choice,
          travel_preferences: travelPreferences || {
            sightseeing: 25,
            nature: 25,
            culture: 20,
            Restaurant: 20,
            entertainment: 10,
          },
        },
      };

      try {
        // Call generate_plan API
        const res = await generateItinerary(body);

        if (!res.multi_day_itinerary) {
          throw new Error("Server didn't return multi_day_itinerary");
        }

        // Update global activities
        changeAllActivities(res.multi_day_itinerary);
        setItinerary(res.multi_day_itinerary);

        // Extract map coordinates
        const locations = await extractLocationsWithCoordinates(
          res.multi_day_itinerary
        );
        setChatLocations(locations);

        // Remove loading message
        setBlocks((prev) =>
          prev.filter((block) => !block.text?.includes("Crafting your perfect"))
        );

        // Add success message
        appendBlock({
          type: "chat",
          who: "ai",
          text: `✨ Your personalized ${res.multi_day_itinerary.length}-day Montreal itinerary is ready! Here's what I've planned for you:`,
        });

        // // Generate and display itinerary text
        // const itineraryText = generateItineraryText(res.multi_day_itinerary);
        // appendBlock({
        //   type: "chat",
        //   who: "ai",
        //   text: itineraryText,
        // });

        // Add action buttons
        appendBlock({
          type: "dual-buttons",
          buttons: [
            {
              label: "Print PDF",
              onClick: handlePrintPDF,
              className: "btn-success",
            },
            {
              label: "Add to My Trip",
              onClick: () =>
                handleAddItineraryToMyTripDirect(res.multi_day_itinerary),
              className: "btn-info",
            },
            {
              label: "Modify Itinerary",
              onClick: handleModifyItinerary,
              className: "btn-primary",
            },
          ],
        });

        // Expand map
        setMapExpanded(true);

        // Optional: Add follow-up AI message
        setTimeout(() => {
          appendBlock({
            type: "chat",
            who: "ai",
            text: "Feel free to ask me any questions about your itinerary, specific places, or if you'd like to make any adjustments! 😊",
          });
        }, 2000);
      } catch (err) {
        console.error("Error generating itinerary:", err);

        // Remove loading message
        setBlocks((prev) =>
          prev.filter((block) => !block.text?.includes("Crafting your perfect"))
        );

        appendBlock({
          type: "chat",
          who: "ai",
          text: "😞 I'm sorry, I encountered an error while creating your itinerary. Let me try a different approach...",
        });

        // Optionally retry or offer alternatives
        setTimeout(() => {
          appendBlock({
            type: "chat",
            who: "ai",
            text: "Would you like me to try again, or would you prefer to adjust your preferences?",
          });

          appendBlock({
            type: "preference",
            stage: "error_recovery",
            options: ["Try Again", "Change Preferences", "Contact Support"],
          });
        }, 1000);
      }
    }
    // Handle error recovery options
    else if (stage === "error_recovery") {
      switch (choice) {
        case "Try Again":
          // Retry the last tier selection
          handleOptionClick("tier", selectedTier || "Signature");
          break;

        case "Change Preferences":
          appendBlock({
            type: "chat",
            who: "ai",
            text: "No problem! What would you like to change? Your activity type, cuisine preference, or budget tier?",
          });

          appendBlock({
            type: "preference",
            stage: "modify",
            options: [
              "Activity Type",
              "Cuisine Preference",
              "Budget Tier",
              "Start Over",
            ],
          });
          break;

        case "Contact Support":
          appendBlock({
            type: "chat",
            who: "ai",
            text: "I understand your frustration. Please contact our support team at support@citygetaways.com or use the help button in the menu. They'll assist you right away!",
          });
          break;
      }
    }

    // Handle modification options
    else if (stage === "modify") {
      switch (choice) {
        case "Activity Type":
          appendBlock({
            type: "chat",
            who: "ai",
            text: "Let's reconsider your activity preference. What sounds most appealing now?",
          });
          appendBlock({
            type: "preference",
            stage: "activity",
            options: [
              "Adventure",
              "Nature",
              "City Strolls",
              "Cultural Immersion",
            ],
          });
          break;

        case "Cuisine Preference":
          appendBlock({
            type: "chat",
            who: "ai",
            text: "Let's explore different cuisine options. What would you like to try?",
          });
          appendBlock({
            type: "preference",
            stage: "cuisine",
            options: ["French", "Italian", "Local Specialties", "Asian Fusion"],
          });
          break;

        case "Budget Tier":
          appendBlock({
            type: "chat",
            who: "ai",
            text: "Let's adjust your budget preference. Which tier works better for you?",
          });
          appendBlock({
            type: "preference",
            stage: "tier",
            options: ["Basic", "Signature", "Luxury"],
          });
          break;

        case "Start Over":
          handleSmartCommands("restart");
          break;
      }
    }
  };

  const handlePrintPDF = () => {
    console.log("Print PDF button clicked!");

    // 简单的5天行程文本
    const simpleItinerary = `Day 1: Arrival and Old Montreal Exploration
Begin your adventure in Montreal by checking into your hotel, then take a leisurely stroll through Old Montreal's cobblestone streets. Along the way, you'll visit: Joe Beef, Notre-Dame Basilica, Toqué!, Mount Royal Park and L'Express.

Day 2: Cultural Immersion and Art
Start with a visit to the Montreal Museum of Fine Arts for its impressive collection. Along the way, you'll visit: Dandy, Old Montréal (Vieux-Montréal) and Old Port, Olive et Gourmando, Hop-On Hop-Off Double-Decker Tour and Schwartz's Deli.

Day 3: Nature and Relaxation
Spend the morning at Mount Royal Park for panoramic city views. Along the way, you'll visit: Tommy Café, Montreal Museum of Fine Arts, Eggspectation, Mount Royal Park, Saint Joseph's Oratory of Mount Royal and Pizzeria Bros (Old Montreal).

Day 4: Local Flavors and Nightlife
Discover culinary delights at Jean-Talon Market, then experience Griffintown's vibrant nightlife. Along the way, you'll visit: le passe compose, Montmorency Falls, Old Quebec City, Schwartz's Deli, Château Frontenac and Montreal Museum of Fine Arts.

Day 5: Farewell and Last-Minute Shopping
On your last day, explore boutiques along Saint Catherine Street before you depart. Along the way, you'll visit: Hotel Checkout.`;

    // 创建简单的PDF窗口
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>Montreal Itinerary</title>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    line-height: 1.6;
                    max-width: 800px;
                    margin: 0 auto;
                    padding: 20px;
                    color: #333;
                }
                h1 {
                    text-align: center;
                    color: #2c5282;
                    border-bottom: 2px solid #2c5282;
                    padding-bottom: 10px;
                }
                .itinerary {
                    white-space: pre-line;
                    font-size: 16px;
                    line-height: 1.8;
                }
                .no-print {
                    text-align: center;
                    margin-top: 30px;
                    border-top: 1px solid #ccc;
                    padding-top: 20px;
                }
                button {
                    padding: 10px 20px;
                    margin: 0 10px;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    font-size: 16px;
                }
                .print-btn {
                    background: #2c5282;
                    color: white;
                }
                .close-btn {
                    background: #e53e3e;
                    color: white;
                }
                @media print {
                    .no-print { display: none; }
                }
            </style>
        </head>
        <body>
            <h1>Montreal 5-Day Itinerary</h1>
            <p><strong>Generated:</strong> ${new Date().toLocaleDateString()}</p>
            <p><strong>Selected Tier:</strong> ${
              selectedTier || "Not selected"
            }</p>
            
            <div class="itinerary">
${simpleItinerary}
            </div>
            
            <div class="no-print">
                <button class="print-btn" onclick="window.print()">Print PDF</button>
                <button class="close-btn" onclick="window.close()">Close</button>
            </div>
        </body>
        </html>
    `);
    printWindow.document.close();
  };

  // 🎨 创建漂亮的PDF内容
  const createBeautifulPDF = (itineraryText) => {
    // 按天分割文本
    const days = itineraryText.split(/(?=Day \d+:)/);

    let content = "";

    days.forEach((dayText, index) => {
      if (!dayText.trim()) return;

      // 提取日期信息
      const dayMatch = dayText.match(/Day (\d+): ([^\n]*)/);
      if (!dayMatch) return;

      const dayNumber = dayMatch[1];
      const dayTitle = dayMatch[2];

      // 提取描述和地点
      const lines = dayText.split("\n").filter((line) => line.trim());
      const description =
        lines.find(
          (line) =>
            !line.startsWith("Day") &&
            !line.includes("Along the way, you'll visit:")
        ) || "";

      const placesLine = lines.find((line) =>
        line.includes("Along the way, you'll visit:")
      );
      let places = "";

      if (placesLine) {
        const placesMatch = placesLine.match(
          /Along the way, you'll visit: (.*?)\.?$/
        );
        if (placesMatch) {
          places = placesMatch[1].replace(
            /\*\*(.*?)\*\*/g,
            '<span class="place-tag">$1</span>'
          );
        }
      }

      content += `
            <div class="day-section">
                <div class="day-number">${dayNumber}</div>
                <h2 class="day-title">${dayTitle}</h2>
                <div class="day-description">
                    ${description.replace(
                      /\*\*(.*?)\*\*/g,
                      '<strong style="color: #667eea;">$1</strong>'
                    )}
                </div>
                ${
                  places
                    ? `
                    <div class="places-section">
                        <div class="places-title">Places you'll visit</div>
                        <div class="places-list">
                            ${places}
                        </div>
                    </div>
                `
                    : ""
                }
            </div>
        `;
    });

    return content;
  };

  // After all selections, or at any time, the user can type free‐text and send
  const handleSend = async () => {
    const trimmed = inputText.trim();
    if (!trimmed) return;

    appendBlock({ type: "chat", who: "user", text: trimmed });
    setInputText("");

    // 🆕 【智能检测逻辑】
    if (checkIfContainsDateInfo(trimmed)) {
      console.log("🎯 Detected date/day planning request");
      setIsAIThinking(true);
      setThinkingStage("processing");

      try {
        const result = await processRequest(trimmed, {
          currentPage: "chatPage",
          hasExistingItinerary: itinerary.length > 0,
        });

        setIsAIThinking(false);

        if (result.success) {
          console.log("🎯 Smart planning success!");
          console.log("🗺️ result.itinerary:", result.itinerary);
          console.log("🗺️ result.itinerary type:", typeof result.itinerary);
          console.log("🗺️ result.itinerary length:", result.itinerary?.length);

          // 检查每一天的数据结构
          if (result.itinerary && result.itinerary.length > 0) {
            result.itinerary.forEach((day, index) => {
              console.log(`🗺️ Day ${index + 1}:`, day);
              console.log(`🗺️ Day ${index + 1} plan:`, day.plan);
            });
          }

          setItinerary(result.itinerary);
          changeAllActivities(result.itinerary);
          // 成功生成智能规划
          setItinerary(result.itinerary);
          changeAllActivities(result.itinerary);

          appendBlock({
            type: "chat",
            who: "ai",
            text: result.message,
          });

          // 🔥 这里也只调用一次
          setTimeout(() => {
            const itineraryText = generateDynamicItineraryText(
              result.itinerary
            );

            // 🔥 只有当文本不为空时才添加
            if (itineraryText.trim()) {
              appendBlock({
                type: "chat",
                who: "ai",
                text: itineraryText,
              });
            }

            // 添加操作按钮
            setTimeout(() => {
              appendBlock({
                type: "dual-buttons",
                buttons: [
                  {
                    label: " Print PDF",
                    onClick: handlePrintPDF,
                    className: "btn-success",
                  },
                  {
                    label: " Add to My Trip",
                    onClick: () =>
                      handleAddItineraryToMyTripDirect(result.itinerary),
                    className: "btn-info",
                  },
                  {
                    label: " Modify Itinerary",
                    onClick: handleModifyItinerary,
                    className: "btn-primary",
                  },
                ],
              });
            }, 500);
          }, 1000);

          // 更新地图
          extractLocationsWithCoordinates(result.itinerary).then(
            setChatLocations
          );
          setMapExpanded(true);
          setIsSmartPlanActive(true);
        } else {
          // 智能规划失败
          appendBlock({
            type: "chat",
            who: "ai",
            text: result.message || "抱歉，我无法根据您提供的信息生成行程。",
          });

          if (result.suggestions) {
            setTimeout(() => {
              appendBlock({
                type: "preference",
                stage: "suggestions",
                options: result.suggestions,
              });
            }, 1000);
          }
        }
      } catch (error) {
        setIsAIThinking(false);
        console.error("Smart planning error:", error);
        appendBlock({
          type: "chat",
          who: "ai",
          text: "处理您的请求时遇到错误，让我用其他方式帮助您。",
        });
      }

      return; // 🚨 重要：这里return，不执行后面的原有逻辑
    }

    // 原有的流程管理逻辑...
    setIsAIThinking(true);
    setThinkingStage("thinking");

    // Use flow manager to process input
    const decision = await flowManager.processUserInput(trimmed, {
      userChoices,
      hasItinerary: itinerary.length > 0,
      aiService,
      candidates,
    });

    setIsAIThinking(false);
    console.log("Flow decision:", decision);

    switch (decision.type) {
      case "direct_choice":
        // User directly selected an option
        handleDirectChoice(decision);
        break;

      case "command":
        // Handle special commands
        handleCommand(decision);
        break;

      case "guided_chat":
        // AI response + show options
        await handleGuidedChat(decision);
        break;

      case "ai_chat":
        // Pure AI chat
        await handleAIChat(decision);
        break;

      case "modify_choices":
        await handleUserModification(decision.intent, decision.entity);
        break;
      case "user_input_choice":
        handleUserInputChoice(decision);
        break;
    }
  };
  const handleUserInputChoice = async (decision) => {
    const { stage, choice, response } = decision;

    // 更新用户选择
    setUserChoices((prev) => ({
      ...prev,
      [stage.toLowerCase()]: choice,
    }));

    // 回复确认
    appendBlock({
      type: "chat",
      who: "ai",
      text: response,
    });
    if (pendingReplacement) {
      console.log("choice", choice);
      try {
        const replaceRes = await replaceActivity(
          itinerary, // multiDayItinerary
          pendingReplacement.dayIndex, // dayIndex
          "684c2d3a8e4360cebe0d6003", // plan_id
          choice, // newActivityDetails
          pendingReplacement.oldPlaceId, // old_place_id
          pendingReplacement.oldActivityName // old_activity_name
        );

        // 更新 itinerary
        setItinerary(replaceRes.multi_day_itinerary);

        const updatedIntro = generateUpdatedDayIntro(
          pendingReplacement.dayIndex,
          replaceRes,
          pendingReplacement.oldActivityName
        );

        appendBlock({
          type: "chat",
          who: "ai",
          text: `✅ I've updated your plan with **${choice.name}**!\n\n${updatedIntro}`,
        });

        setCandidates([]);
        setPendingReplacement(null);
      } catch (err) {
        console.error("Replace error:", err);
      }
    }

    // 检查是否进入下一个阶段
    // const nextStage = flowManager.getNextStage(stage);
    // if (nextStage === flowManager.stages.COMPLETE) {
    //   setTimeout(() => {
    //     appendBlock({
    //       type: "chat",
    //       who: "ai",
    //       text: "Perfect! I have all the information I need. Let me create your personalized Montreal itinerary... 🚀",
    //     });
    //     handleOptionClick("tier", choice);
    //   }, 1000);
    // } else {
    //   setTimeout(() => {
    //     showStageOptions(nextStage);
    //   }, 1500);
    // }
  };

  const handleUserModification = async (intent, entity) => {
    if (intent === "change_restaurant") {
      const restaurant = findActivityWithDayByName(entity, itinerary);
      console.log("rest", restaurant);
      console.log("itinerary", itinerary);

      if (restaurant) {
        appendBlock({
          type: "chat",
          who: "ai",
          text: `🔄 Looking for alternative restaurants to replace **${
            restaurant.activity.location || restaurant.activity.name
          }**...`,
        });

        const requestBody = {
          multi_day_itinerary: itinerary,
          plan_id: "684c2d3a8e4360cebe0d6003",
          place_id: restaurant.activity.place_id,
          day_index: restaurant.day,
          type: "restaurant",
        };

        try {
          console.log("request", requestBody);
          const response = await changeActivity(requestBody);
          console.log("response", response);

          if (response?.candidates?.length > 0) {
            console.log("2115", restaurant);
            console.log("2114", restaurant.activity.name);
            setCandidates(response.candidates);
            setPendingReplacement({
              oldPlaceId: restaurant.activity.place_id,
              dayIndex: restaurant.day,
              oldActivityName: restaurant.activity.name,
            });
            appendBlock({
              type: "chat",
              who: "ai",
              text: `🍽️ I found some alternatives to replace **${response.old_activity_name}**. Which one do you like?`,
            });

            // 把所有候选推荐显示出来
            response.candidates.forEach((candidate, index) => {
              appendBlock({
                type: "chat",
                who: "ai",
                text:
                  `Option ${index + 1}:**${candidate.name}**\n\n` +
                  `📍 ${candidate.category}\n\n` +
                  `${candidate.description || "No description available."}\n\n`,
              });
            });
          } else {
            appendBlock({
              type: "chat",
              who: "ai",
              text: `❌ Sorry, I couldn’t find alternatives for "${entity}".`,
            });
          }
        } catch (error) {
          console.error("Error updating activity:", error);
        }
      } else {
        appendBlock({
          type: "chat",
          who: "ai",
          text: `❌ Couldn’t find a restaurant called "${entity}". Try a different name?`,
        });
      }
    }
  };

  const findActivityWithDayByName = (name, itinerary) => {
    for (let dayIndex = 0; dayIndex < itinerary.length; dayIndex++) {
      const dayPlan = itinerary[dayIndex];
      for (const activity of dayPlan.activities || dayPlan.plan || []) {
        const activityName = activity.name || activity.location;
        if (
          activityName &&
          activityName.toLowerCase().includes(name.toLowerCase())
        ) {
          return {
            day: dayIndex,
            activity,
          };
        }
      }
    }
    return null;
  };

  const generateUpdatedDayIntro = (dayIndex, dayPlan, oldActivityName) => {
    const dayNum = dayIndex + 1;
    console.log("1469", dayPlan);

    // Optional: customize intros per day if desired
    const dayIntros = {
      1: `Day 1: Arrival and Old Montreal Exploration`,
      2: `Day 2: Cultural Immersion and Art`,
      3: `Day 3: Nature and Relaxation`,
      4: `Day 4: Local Flavors and Nightlife`,
      5: `Day 5: Farewell and Last-Minute Shopping`,
    };

    const intro = dayIntros[dayNum] || `Day ${dayNum}`;
    const activities = dayPlan.multi_day_itinerary[dayIndex].plan;
    console.log("2191 name", oldActivityName);

    const filteredActivities = activities.filter(
      (act) => (act.name || act.location) !== oldActivityName
    );

    const activityNames = filteredActivities.map(
      (act) => `**${act.location || act.name}**`
    );
    const activityList = activityNames
      .join(", ")
      .replace(/, ([^,]*)$/, " and $1");

    return `${intro}\n\nYour updated plan for this day includes: ${activityList}.`;
  };

  const handleDirectChoice = (decision) => {
    const { stage, choice, response } = decision;

    // Update user choices
    setUserChoices((prev) => ({
      ...prev,
      [stage.toLowerCase()]: choice,
    }));

    // Show confirmation message
    appendBlock({
      type: "chat",
      who: "ai",
      text: response,
    });

    // Check if ready to generate itinerary
    const nextStage = flowManager.getNextStage(stage);
    if (nextStage === flowManager.stages.COMPLETE) {
      // Start generating itinerary
      setTimeout(() => {
        appendBlock({
          type: "chat",
          who: "ai",
          text: "Perfect! I have all the information I need. Let me create your personalized Montreal itinerary... 🚀",
        });
        handleOptionClick("tier", choice);
      }, 1000);
    } else {
      // Show next stage options
      setTimeout(() => {
        showStageOptions(nextStage);
      }, 1500);
    }
  };
  const handleGuidedChat = async (decision) => {
    setIsAIThinking(true);
    setThinkingStage("analyzing");

    try {
      // Build context-aware prompt
      const prompt = flowManager.buildAIPrompt(inputText, {
        currentStage: decision.stage,
        userChoices,
      });

      const response = await aiService.sendMessage(prompt);

      setIsAIThinking(false);
      // Show AI response
      handleAIResponse(response);

      // Show options if needed
      if (
        decision.showOptionsAfter &&
        !userChoices[decision.stage.toLowerCase()]
      ) {
        setTimeout(() => {
          showStageOptions(decision.stage);
        }, 1500);
      }
    } catch (error) {
      setIsAIThinking(false);
      handleAIError(error);
    }
  };

  const showStageOptions = (stage) => {
    const stageConfig = flowManager.stageOptions[stage];
    if (!stageConfig) return;

    appendBlock({
      type: "preference",
      stage: stage.toLowerCase(),
      options: stageConfig.options,
    });
  };

  // Handle special commands
  const handleCommand = (decision) => {
    switch (decision.command) {
      case "quick_generate":
        setUserChoices(decision.defaultChoices);
        appendBlock({
          type: "chat",
          who: "ai",
          text: "Great! I'll quickly generate an itinerary with these recommended settings:\n• Activity: City Strolls\n• Cuisine: Local Specialties\n• Budget: Signature tier",
        });
        setTimeout(() => {
          handleOptionClick("tier", "Signature");
        }, 1500);
        break;

      case "restart":
        setBlocks([
          {
            type: "chat",
            who: "ai",
            text: "Let's start fresh! What kind of Montreal experience are you looking for?",
          },
        ]);
        setUserChoices({});
        setItinerary([]);
        setChatLocations([]);
        setTimeout(() => {
          showStageOptions(flowManager.stages.ACTIVITY);
        }, 1000);
        break;

      case "modify_choices":
        appendBlock({
          type: "chat",
          who: "ai",
          text: "Which preference would you like to change? Let me know what you'd like to modify.",
        });
        break;
    }
  };

  // Handle pure AI chat
  const handleAIChat = async (decision) => {
    setIsAIThinking(true);
    setThinkingStage("processing");

    try {
      const response = await aiService.sendMessage(inputText, {
        userChoices,
        currentStage: getCurrentStage(),
        hasItinerary: itinerary.length > 0,
      });

      setIsAIThinking(false);
      handleAIResponse(response);
    } catch (error) {
      setIsAIThinking(false);
      handleAIError(error);
    }
  };

  // Handle AI errors
  const handleAIError = (error) => {
    console.error("AI Error:", error);
    setBlocks((prev) => prev.filter((block) => !block.isLoading));
    appendBlock({
      type: "chat",
      who: "ai",
      text: "I apologize, I encountered an error. Please try again.",
    });
  };
  const getDefaultOptionsForStage = (stage) => {
    const options = {
      ACTIVITY: ["Adventure", "Nature", "City Strolls", "Cultural Immersion"],
      CUISINE: ["French", "Italian", "Local Specialties", "Asian Fusion"],
      TIER: ["Basic", "Signature", "Luxury"],
      CUSTOM: [],
    };
    return options[stage] || [];
  };

  const handleSmartCommands = (message) => {
    const lowerMessage = message.toLowerCase();

    // 快速跳过偏好收集
    if (lowerMessage.includes("快速生成") || lowerMessage.includes("skip")) {
      setUserChoices({
        activity: "City Strolls",
        cuisine: "Local Specialties",
        tier: "Signature",
      });
      handleOptionClick("tier", "Signature");
      return true;
    }

    // 重新开始
    if (lowerMessage.includes("重新开始") || lowerMessage.includes("restart")) {
      setBlocks([blocks[0]]);
      setUserChoices({});
      setItinerary([]);
      setChatLocations([]);
      return true;
    }

    return false;
  };

  const handleAIResponse = async (response) => {
    try {
      if (!response || typeof response !== "object") {
        throw new Error("Invalid AI response format");
      }

      console.log("Processing AI response:", response);

      switch (response.type) {
        case "message":
          appendBlock({ type: "chat", who: "ai", text: response.message });

          if (response.suggestions && Array.isArray(response.suggestions)) {
            appendBlock({
              type: "preference",
              stage: "suggestions",
              options: response.suggestions,
            });
          }
          break;

        case "itinerary":
          if (response.message) {
            appendBlock({ type: "chat", who: "ai", text: response.message });
          }

          // 🆕 支持动态行程数据
          if (response.data) {
            await processDynamicItinerary(response.data);
          } else {
            throw new Error("Itinerary data missing");
          }
          break;

        case "preference":
          if (response.message) {
            appendBlock({ type: "chat", who: "ai", text: response.message });
          }

          appendBlock({
            type: "preferences",
            days: response.days ?? null,
            budget: response.budget ?? null,
            notes: response.notes ?? null,
          });
          break;

        default:
          appendBlock({
            type: "chat",
            who: "ai",
            text:
              response.message ||
              "I understand. How can I help with your travel planning?",
          });
      }
    } catch (error) {
      console.error("Error handling AI response:", error);
      appendBlock({
        type: "chat",
        who: "ai",
        text: "I had trouble understanding that. Let me help you plan your trip step by step.",
      });

      // 显示引导选项
      setTimeout(() => {
        appendBlock({
          type: "preference",
          stage: "activity",
          options: [
            "Adventure",
            "Nature",
            "City Strolls",
            "Cultural Immersion",
          ],
        });
      }, 1000);
    }
  };

  const processDynamicItinerary = async (itineraryData) => {
    try {
      // 🔥 关键修改：支持不同的数据结构
      let processedItinerary;

      if (itineraryData.multi_day_itinerary) {
        // 标准格式
        processedItinerary = itineraryData.multi_day_itinerary;
      } else if (Array.isArray(itineraryData)) {
        // 直接是数组格式
        processedItinerary = itineraryData;
      } else if (itineraryData.itinerary) {
        // 嵌套在 itinerary 字段中
        processedItinerary = itineraryData.itinerary;
      } else {
        throw new Error("Unknown itinerary data structure");
      }

      // 验证数据
      if (
        !Array.isArray(processedItinerary) ||
        processedItinerary.length === 0
      ) {
        throw new Error("Invalid itinerary structure");
      }

      console.log(`🎯 Processing ${processedItinerary.length}-day itinerary`);

      // 更新状态
      changeAllActivities(processedItinerary);
      setItinerary(processedItinerary);

      // 提取地图坐标
      const locations = await extractLocationsWithCoordinates(
        processedItinerary
      );
      setChatLocations(locations);

      // 生成行程文本 - 🆕 支持动态天数
      const itineraryText = generateDynamicItineraryText(processedItinerary);
      appendBlock({
        type: "chat",
        who: "ai",
        text: itineraryText,
      });

      // 添加操作按钮
      appendBlock({
        type: "dual-buttons",
        buttons: [
          {
            label: " Print PDF",
            onClick: handlePrintPDF,
            className: "btn-success",
          },
          {
            label: " Add to My Trip",
            onClick: () => handleAddItineraryToMyTripDirect(processedItinerary),
            className: "btn-info",
          },
          {
            label: " Modify Itinerary",
            onClick: handleModifyItinerary,
            className: "btn-primary",
          },
        ],
      });

      // 展开地图
      setMapExpanded(true);
    } catch (error) {
      console.error("Error processing dynamic itinerary:", error);
      appendBlock({
        type: "chat",
        who: "ai",
        text: "Sorry, I had trouble processing the itinerary data. Let me try a different approach.",
      });
    }
  };
  const generateItineraryTextOnce = useCallback(
    async (itineraryData, source = "unknown") => {
      console.log(`🎯 generateItineraryTextOnce called from: ${source}`);

      if (isGeneratingText) {
        console.log("🚫 Already generating text, skipping...");
        return false;
      }

      if (
        !itineraryData ||
        !Array.isArray(itineraryData) ||
        itineraryData.length === 0
      ) {
        console.log("❌ Invalid itinerary data");
        return false;
      }

      const dataHash = JSON.stringify(itineraryData);
      if (lastGeneratedItineraryHash === dataHash) {
        console.log("🚫 Same itinerary data, skipping text generation");
        return false;
      }

      setIsGeneratingText(true);
      setLastGeneratedItineraryHash(dataHash);

      try {
        const itineraryText = generateDynamicItineraryText(itineraryData);

        if (itineraryText.trim()) {
          appendBlock({
            type: "chat",
            who: "ai",
            text: itineraryText,
          });

          console.log(
            `✅ Itinerary text generated successfully from: ${source}`
          );
          return true;
        }

        return false;
      } finally {
        setTimeout(() => {
          setIsGeneratingText(false);
        }, 2000);
      }
    },
    [lastGeneratedItineraryHash, isGeneratingText]
  );

  const generateDynamicItineraryText = (itineraryData) => {
    const currentDataString = JSON.stringify(itineraryData);
    const now = Date.now();

    // 如果在2秒内生成过相同内容，直接返回空
    if (
      window.lastGeneratedText === currentDataString &&
      window.lastGeneratedTime &&
      now - window.lastGeneratedTime < 2000
    ) {
      console.log("🚫 Preventing duplicate text generation (time-based)");
      return "";
    }

    window.lastGeneratedText = currentDataString;
    window.lastGeneratedTime = now;

    if (!Array.isArray(itineraryData) || itineraryData.length === 0) {
      return "I've prepared your travel itinerary, but there seems to be an issue with the data.";
    }

    const dayCount = itineraryData.length;
    const dayTexts = itineraryData.map((dayObj, idx) => {
      const dayNum = idx + 1;
      const activities = dayObj.plan || dayObj.activities || [];

      if (activities.length === 0) {
        return `**Day ${dayNum}:** Free day for personal exploration.`;
      }

      const activityNames = activities
        .map((act) => act.location || act.activity || act.name)
        .filter((name) => name)
        .map((name) => `**${name}**`);

      let description = "";

      if (dayNum === 1) {
        description =
          "Begin your adventure by checking into your accommodation and exploring the local area.";
      } else if (dayNum === dayCount) {
        description =
          "On your final day, enjoy some last-minute activities before departure.";
      } else {
        description = `Day ${dayNum} brings exciting discoveries and memorable experiences.`;
      }

      const placesText =
        activityNames.length > 0
          ? activityNames.join(", ").replace(/, ([^,]*)$/, " and $1")
          : "various local attractions";

      return `**Day ${dayNum}:** ${description} Along the way, you'll visit: ${placesText}.`;
    });

    const intro = `✨ Your personalized ${dayCount}-day itinerary is ready! Here's what I've planned for you:\n\n`;

    return intro + dayTexts.join("\n\n");
  };

  const SmartAvatar = ({ who, isThinking = false, isActive = false }) => {
    const baseClass = who === "user" ? "user-minimal" : "ai-minimal";
    const stateClasses = [
      "avatar",
      baseClass,
      isThinking && "loading",
      isActive && "active",
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <div className={stateClasses}>
        {who === "user" ? ChatAvatars.user : ChatAvatars.ai}
      </div>
    );
  };

  const processItinerary = async (itineraryData) => {
    try {
      // 验证数据结构
      if (!itineraryData || !itineraryData.multi_day_itinerary) {
        throw new Error("Invalid itinerary data structure");
      }

      // 更新状态
      const multiDayItinerary = itineraryData.multi_day_itinerary;
      changeAllActivities(multiDayItinerary);
      setItinerary(multiDayItinerary);

      // 提取并获取所有地点的坐标
      const locations = await extractLocationsWithCoordinates(
        multiDayItinerary
      );
      setChatLocations(locations);

      // 生成行程文本描述
      const itineraryText = generateItineraryText(multiDayItinerary);
      appendBlock({
        type: "chat",
        who: "ai",
        text: itineraryText,
      });

      // 添加操作按钮
      appendBlock({
        type: "dual-buttons",
        buttons: [
          {
            label: " Print PDF",
            onClick: handlePrintPDF,
            className: "btn-success",
          },
          {
            label: " Add to My Trip",
            onClick: () => handleAddItineraryToMyTripDirect(multiDayItinerary),
            className: "btn-info",
          },
          {
            label: " Modify Itinerary",
            onClick: handleModifyItinerary,
            className: "btn-primary",
          },
        ],
      });

      // 展开地图
      setMapExpanded(true);
    } catch (error) {
      console.error("Error processing itinerary:", error);
      appendBlock({
        type: "chat",
        who: "ai",
        text: "抱歉，处理行程数据时出现错误。请重试。",
      });
    }
  };
  const extractLocationsWithCoordinates = async (multiDayItinerary) => {
    const locationPromises = multiDayItinerary.flatMap((day) =>
      day.plan
        .filter(
          (act) =>
            act.place_id &&
            act.place_id !== "undefined" &&
            act.place_id.trim() !== ""
        )
        .map(async (act) => {
          // 酒店硬编码处理
          if (act.place_id === "hotel_checkin") {
            return {
              name: act.location || act.name,
              lat: 45.5083,
              lng: -73.5617,
            };
          }

          // 🆕 处理 fallback place_id
          if (act.place_id.startsWith("fallback_")) {
            console.log(
              "🔄 检测到 fallback place_id，使用蒙特利尔默认区域坐标"
            );
            const baseLat = 45.5017;
            const baseLng = -73.5673;
            const randomOffsetLat = (Math.random() - 0.5) * 0.02;
            const randomOffsetLng = (Math.random() - 0.5) * 0.02;

            return {
              name: act.location || act.name,
              lat: baseLat + randomOffsetLat,
              lng: baseLng + randomOffsetLng,
              placeId: act.place_id,
              activityData: act,
            };
          }

          try {
            // 调用后端API获取坐标
            const resp = await fetch(
              `https://citygetaway-backend-plan-service.vercel.app/api/place_lat_lng?place_id=${act.place_id}`,
              {
                headers: {
                  "X-User-Name": "testDan",
                  "X-User-Id": "681a6db71771cb427864f564",
                },
              }
            );

            if (!resp.ok) {
              console.error(`Failed to fetch coordinates for ${act.place_id}`);
              return null;
            }

            const data = await resp.json();
            console.log("🔍 服务器返回的完整数据：", data); // 🆕 添加这行调试

            if (data.error) {
              console.error(`API error for ${act.place_id}:`, data.error);
              return null;
            }

            // 🔥 关键修改：确保坐标转换为数字类型
            const lat = parseFloat(data.lat ?? data.latitude ?? "");
            const lng = parseFloat(data.lng ?? data.longitude ?? "");

            console.log("🔍 解析的坐标：", {
              originalLat: data.lat,
              originalLng: data.lng,
              parsedLat: lat,
              parsedLng: lng,
              latType: typeof lat,
              lngType: typeof lng,
              latIsNaN: isNaN(lat),
              lngIsNaN: isNaN(lng),
            }); // 🆕 添加这行调试

            if (isNaN(lat) || isNaN(lng)) {
              console.error(`Invalid coordinates for ${act.place_id}:`, data);
              return null;
            }

            return {
              name: act.location || act.name,
              lat, // 🔥 确保这里是 number 类型
              lng, // 🔥 确保这里是 number 类型
              placeId: act.place_id,
              activityData: act,
            };
          } catch (error) {
            console.error(
              `Error fetching coordinates for ${act.place_id}:`,
              error
            );
            return null;
          }
        })
    );

    const locations = await Promise.all(locationPromises);

    // 过滤掉null值并验证坐标
    const validLocations = locations.filter(
      (loc) =>
        loc !== null &&
        typeof loc.lat === "number" &&
        !isNaN(loc.lat) &&
        typeof loc.lng === "number" &&
        !isNaN(loc.lng)
    );

    // 🆕 添加详细调试信息
    console.log("🎯 最终有效位置数量：", validLocations.length);
    validLocations.forEach((loc, index) => {
      console.log(`位置 ${index + 1}:`, {
        name: loc.name,
        lat: loc.lat,
        lng: loc.lng,
        latType: typeof loc.lat,
        lngType: typeof loc.lng,
      });
    });

    return validLocations;
  };

  const generateItineraryText = (multiDayItinerary) => {
    const paragraphs = multiDayItinerary.map((dayObj, idx) => {
      const dayNum = idx + 1;
      const activities = dayObj.plan.map((act) => act.location || act.name);

      // 使用你原有的日程介绍文本
      const dayIntros = {
        1: `Day 1: Arrival and Old Montreal Exploration\n\nBegin your adventure in Montreal by **checking into your hotel**, then take a leisurely stroll through Old Montreal's cobblestone streets.`,
        2: `Day 2: Cultural Immersion and Art\n\nStart with a visit to the Montreal Museum of Fine Arts for its impressive collection.`,
        3: `Day 3: Nature and Relaxation\n\nSpend the morning at Mount Royal Park for panoramic city views.`,
        4: `Day 4: Local Flavors and Nightlife\n\nDiscover culinary delights at Jean-Talon Market, then experience Griffintown's vibrant nightlife.`,
        5: `Day 5: Farewell and Last-Minute Shopping\n\nOn your last day, explore boutiques along Saint Catherine Street before you depart.`,
      };

      const intro = dayIntros[dayNum] || `**Day ${dayNum}**`;

      const boldPlaces = activities.map((name) => `**${name}**`);
      let middle = boldPlaces.join(", ");
      middle = middle.replace(/, ([^,]*)$/, " and $1");

      return `${intro} Along the way, you'll visit: ${middle}.`;
    });

    return paragraphs.join("\n\n");
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };
  // Render each block:
  const renderBlock = (block, idx, prevBlock) => {
    const showDivider = prevBlock && prevBlock.who !== block.who;

    // 🆕 处理偏好提示按钮
    if (block.type === "preference-prompt") {
      return (
        <div key={idx} className="msg-item text-center">
          {showDivider && <hr className="divider" />}
          <div className="d-flex justify-content-center gap-3 mt-3">
            {block.buttons.map((button, btnIdx) => (
              <button
                key={btnIdx}
                className={`btn ${button.className || "btn-primary"}`}
                onClick={button.onClick}
                style={{ minWidth: "150px" }}
              >
                {button.label}
              </button>
            ))}
          </div>
        </div>
      );
    }

    // 处理其他类型的 blocks...
    if (block.type === "button") {
      return (
        <div key={idx} className="msg-item text-center">
          {showDivider && <hr className="divider" />}
          <button className="btn btn-primary mt-3" onClick={block.onClick}>
            {block.label}
          </button>
        </div>
      );
    }

    if (block.type === "dual-buttons") {
      return (
        <div key={idx} className="msg-item text-center">
          {showDivider && <hr className="divider" />}
          <div className="d-flex justify-content-center gap-3 mt-3">
            {block.buttons.map((button, btnIdx) => (
              <button
                key={btnIdx}
                className={`btn ${button.className || "btn-primary"}`}
                onClick={button.onClick}
                style={{ minWidth: "150px" }}
              >
                {button.label}
              </button>
            ))}
          </div>
        </div>
      );
    }

    // 主要的聊天消息渲染
    return (
      <div key={idx} className="msg-item">
        {showDivider && <hr className="divider" />}
        <div className="msg-row">
          <div className="msg-icon-wrapper">
            {/* 🔥 这里是关键修改：替换原来的 Bootstrap 图标 */}
            <div
              className={`avatar ${
                block.who === "user" ? "user-minimal" : "ai-minimal"
              }`}
            >
              {block.who === "user" ? ChatAvatars.user : ChatAvatars.ai}
            </div>
          </div>
          <div className="msg-text-wrapper">
            <div className="msg-text">
              <ReactMarkdown
                components={{
                  strong({ children }) {
                    const getText = (node) => {
                      if (typeof node === "string") return node;
                      if (Array.isArray(node))
                        return node.map(getText).join("");
                      if (
                        node &&
                        typeof node === "object" &&
                        node.props &&
                        node.props.children
                      ) {
                        return getText(node.props.children);
                      }
                      return "";
                    };

                    const text = getText(children);
                    const activityData =
                      nameToActivityData[text] ||
                      nameToActivityData[text.trim()] ||
                      nameToActivityData[text.toLowerCase()] ||
                      nameToActivityData[text.trim().toLowerCase()];

                    if (activityData && activityData.place_id) {
                      return (
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          placement="auto"
                          delay={{ show: 300, hide: 150 }}
                          overlay={
                            <PlacePopover
                              placeId={activityData.place_id}
                              title={text}
                              activityData={activityData}
                            />
                          }
                        >
                          <span
                            className="place-bubble-text"
                            onClick={() => handlePlaceClick(activityData, text)}
                            style={{ cursor: "pointer" }}
                          >
                            {children}
                          </span>
                        </OverlayTrigger>
                      );
                    }

                    return <strong>{children}</strong>;
                  },

                  p({ children }) {
                    return <p style={{ marginBottom: "0.5rem" }}>{children}</p>;
                  },

                  br() {
                    return <br />;
                  },
                }}
              >
                {block.text}
              </ReactMarkdown>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderCombinedAIBlock = (
    chatBlock,
    preferenceBlock,
    idx,
    prevBlock
  ) => {
    const showDivider = prevBlock && prevBlock.who !== chatBlock.who;
    return (
      <div key={`combined-${idx}`} className="msg-item">
        {showDivider && <hr className="divider" />}

        <div className="msg-row">
          <div className="msg-icon-wrapper">
            {/* 🔥 这里也要修改 */}
            <div className="avatar ai-minimal">{ChatAvatars.ai}</div>
          </div>

          <div className="msg-text-wrapper">
            <div className="msg-text mb-2">{chatBlock.text}</div>
            <div className="msg-text mb-2">{preferenceBlock.aiText}</div>
            <div className="options-row">
              {preferenceBlock.options.map((opt, i) => (
                <button
                  key={i}
                  className="option-button"
                  onClick={() => handleOptionClick(preferenceBlock.stage, opt)}
                >
                  {opt}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    // 当 blocks 或 userChoices 发生变化时，自动保存当前聊天
    const saveTimer = setTimeout(() => {
      if (blocks.length > 1 && currentChatId) {
        saveCurrentChat();
      }
    }, 1000); // 延迟1秒保存，避免频繁保存

    return () => clearTimeout(saveTimer);
  }, [blocks, userChoices, itinerary]);

  // 页面卸载保存
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (blocks.length > 1 && currentChatId) {
        saveCurrentChat();
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      // 组件卸载时也保存
      if (blocks.length > 1 && currentChatId) {
        saveCurrentChat();
      }
    };
  }, [blocks, currentChatId]);

  return (
    <Container fluid className="chat-page-container p-0">
      <Row className="h-100 no-gutters">
        {/* ===== Left Sidebar ===== */}

        <Col
          xs={12}
          sm={2}
          md={2}
          lg={2}
          xl="auto"
          className={`modern-sidebar ${
            sidebarCollapsed ? "collapsed" : ""
          } p-0`}
          style={{
            maxWidth: sidebarCollapsed ? "70px" : "220px",
            minWidth: sidebarCollapsed ? "70px" : "180px",
          }}
        >
          {/* 品牌区域 */}
          <div className="sidebar-brand">
            {/* 🆕 添加品牌图标 */}

            <div className="brand-text">
              <div className="brand-title">Citygetaway</div>
              <div className="brand-subtitle">TOURS & TRAVEL</div>
            </div>

            {/* 现代化折叠切换按钮 */}
            <button
              className="sidebar-toggle"
              onClick={handleSidebarToggle}
              data-tooltip={sidebarCollapsed ? "Expand" : "Collapse"}
              aria-label={
                sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"
              }
            >
              <i className="bi bi-chevron-left"></i>
            </button>
          </div>

          {/* 主要功能菜单 */}
          <div className="sidebar-section">
            <div className="menu-items">
              {/* 聊天功能 */}
              <div
                className={`menu-item ${
                  currentView === "chat" ? "active" : ""
                }`}
                onClick={() => handleMenuClick("chat")}
              >
                <div className="menu-icon-wrapper">
                  <i className="bi bi-chat-left-dots"></i>
                </div>
                <div className="menu-content">
                  <div className="menu-label">Chats</div>
                  <div className="menu-description">AI conversations</div>
                </div>
                {/* 🆕 工具提示 */}
                <div className="menu-item-tooltip">Chats</div>
              </div>

              {/* 聊天历史菜单项 */}
              <div
                className={`menu-item ${showChatHistory ? "active" : ""}`}
                onClick={() => setShowChatHistory(!showChatHistory)}
              >
                <div className="menu-icon-wrapper">
                  <i className="bi bi-clock-history"></i>
                  {chatHistory.length > 0 && (
                    <div className="notification-badge">
                      {chatHistory.length}
                    </div>
                  )}
                </div>
                <div className="menu-content">
                  <div className="menu-label">History</div>
                  <div className="menu-description">Previous chats</div>
                </div>
                <div className="menu-item-tooltip">History</div>
              </div>

              {/* 探索功能 */}
              <div
                className={`menu-item ${
                  currentView === "explore" ? "active" : ""
                }`}
                onClick={() => handleMenuClick("explore")}
              >
                <div className="menu-icon-wrapper">
                  <i className="bi bi-compass"></i>
                </div>
                <div className="menu-content">
                  <div className="menu-label">Explore</div>
                  <div className="menu-description">Discover places</div>
                </div>
                <div className="menu-item-tooltip">Explore</div>
              </div>

              {/* 收藏功能 */}
              <div
                className={`menu-item ${
                  currentView === "saved" ? "active" : ""
                }`}
                onClick={() => handleMenuClick("saved")}
              >
                <div className="menu-icon-wrapper">
                  <i className="bi bi-heart"></i>
                  {favorites.length > 0 && (
                    <div className="notification-badge notification-badge-heart">
                      {favorites.length}
                    </div>
                  )}
                </div>
                <div className="menu-content">
                  <div className="menu-label">Saved</div>
                  <div className="menu-description">Favorite places</div>
                </div>
                <div className="menu-item-tooltip">Saved</div>
              </div>

              {/* 我的行程 */}
              <div
                className={`menu-item ${
                  currentView === "mytrip" ? "active" : ""
                }`}
                onClick={() => handleMenuClick("mytrip")}
              >
                <div className="menu-icon-wrapper">
                  <i className="bi bi-suitcase-lg"></i>
                  {myTripItems.length > 0 && (
                    <div className="notification-badge">
                      {myTripItems.length}
                    </div>
                  )}
                </div>
                <div className="menu-content">
                  <div className="menu-label">My Trip</div>
                  <div className="menu-description">Travel itinerary</div>
                </div>
                <div className="menu-item-tooltip">My Trip</div>
              </div>
            </div>
          </div>

          {/* 聊天历史区域 - 只在展开状态且 showChatHistory 为 true 时显示 */}
          {showChatHistory && !sidebarCollapsed && (
            <div className="chat-history-section">
              <div className="section-title">Recent Chats</div>
              <div className="chat-history-list">
                {chatHistory.length === 0 ? (
                  <div className="empty-history">
                    <i className="bi bi-chat-square-text"></i>
                    <span>No chat history yet</span>
                  </div>
                ) : (
                  chatHistory.map((chat) => (
                    <div
                      key={chat.id}
                      className={`chat-history-item ${
                        chat.id === currentChatId ? "current" : ""
                      }`}
                      onClick={() => handleLoadChat(chat)}
                    >
                      <div className="chat-item-content">
                        <div className="chat-title">{chat.title}</div>
                        <div className="chat-timestamp">
                          {new Date(chat.timestamp).toLocaleDateString()}
                        </div>
                        {chat.lastMessage && (
                          <div className="chat-preview">
                            {chat.lastMessage.substring(0, 50)}...
                          </div>
                        )}
                      </div>
                      <button
                        className="delete-chat-btn"
                        onClick={(e) => handleDeleteChat(chat.id, e)}
                        title="Delete chat"
                      >
                        <i className="bi bi-trash3"></i>
                      </button>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}

          {/* 次要功能区域 */}
          <div className="sidebar-section">
            <div className="section-title">Coming soon</div>
            <div className="menu-items">
              {/* 更新功能 - 未实现 */}
              <div className="menu-item disabled">
                <div className="menu-icon-wrapper">
                  <i className="bi bi-bell"></i>
                </div>
                <div className="menu-content">
                  <div className="menu-label">Updates</div>
                  <div className="menu-description">Coming Soon</div>
                </div>
                <div className="coming-soon-tag">Soon</div>
                <div className="menu-item-tooltip">Updates</div>
              </div>

              {/* 灵感功能 - 未实现 */}
              <div className="menu-item disabled">
                <div className="menu-icon-wrapper">
                  <i className="bi bi-lightbulb"></i>
                </div>
                <div className="menu-content">
                  <div className="menu-label">Inspiration</div>
                  <div className="menu-description">Coming Soon</div>
                </div>
                <div className="coming-soon-tag">Soon</div>
                <div className="menu-item-tooltip">Inspiration</div>
              </div>
            </div>
          </div>

          {/* 底部新建聊天按钮 */}
          <div className="sidebar-bottom">
            <button className="new-chat-button" onClick={handleNewChat}>
              <i className="bi bi-plus-circle"></i>
              <span>New Chat</span>
            </button>

            {/* 当前聊天信息 - 只在展开状态显示 */}
            {!sidebarCollapsed && currentChatId && blocks.length > 1 && (
              <div className="current-chat-info">
                <div className="current-chat-title">{generateChatTitle()}</div>
                <div className="current-chat-stats">
                  {blocks.filter((b) => b.who === "user").length} messages
                </div>
              </div>
            )}
          </div>
        </Col>

        {/* ===== Center Content Area ===== */}
        <Col
          xs={12}
          sm={5}
          md={5}
          lg={5}
          xl={5}
          className="d-flex flex-column chat-window p-0"
        >
          {currentView === "explore" ? (
            <ExploreComponent
              onLocationSelect={handleExploreLocationSelect}
              selectedLocations={selectedExploreLocations}
              onAddToFavorites={handleAddToFavorites}
              onAddToMyTrip={handleAddToMyTrip}
              favorites={favorites}
            />
          ) : currentView === "mytrip" ? (
            <MyTripComponent
              myTripItems={myTripItems}
              onRemoveFromTrip={handleRemoveFromMyTrip}
              onUpdateTripItem={handleUpdateTripItem}
              onLocationSelect={handleExploreLocationSelect}
              savedItems={getFavoriteLocations()} // 传入收藏的项目
              onAddToTrip={handleAddFromSavedToTrip} // 从收藏添加到行程的处理函数
            />
          ) : currentView === "saved" ? (
            <SavedComponent
              favorites={favorites}
              allRecommendations={allRecommendations}
              onRemoveFromFavorites={handleRemoveFromFavorites}
              onAddToMyTrip={handleAddToMyTrip}
              onLocationSelect={handleExploreLocationSelect}
            />
          ) : (
            <>
              {/* 🆕 在chat-header前添加 */}
              {isSmartPlanActive && (
                <div
                  className="smart-plan-indicator"
                  style={{
                    backgroundColor: "#e8f5e8",
                    padding: "8px 16px",
                    borderBottom: "1px solid #d4edda",
                    fontSize: "14px",
                    color: "#155724",
                  }}
                >
                  <i className="bi bi-check-circle-fill me-2"></i>
                  Intelligent Planning Mode Activated - {itinerary.length}-day
                  personalized itinerary generated
                </div>
              )}
              <div className="chat-header-modern d-flex align-items-center px-3 py-2">
                <i className="bi bi-robot-fill chat-header-icon me-2"></i>
                <span className="chat-header-title">
                  Concord’s Travel Assistant
                </span>
              </div>

              <div className="chat-messages flex-grow-1 overflow-auto px-3 py-2">
                {blocks.map((block, idx) => {
                  const nextBlock = blocks[idx + 1];
                  const prevBlock = blocks[idx - 1];

                  if (
                    block.type === "chat" &&
                    block.who === "ai" &&
                    nextBlock &&
                    nextBlock.type === "preference"
                  ) {
                    return renderCombinedAIBlock(
                      block,
                      nextBlock,
                      idx,
                      prevBlock
                    );
                  }

                  if (
                    block.type === "preference" &&
                    idx > 0 &&
                    blocks[idx - 1].who === "ai" &&
                    blocks[idx - 1].type === "chat"
                  ) {
                    return null;
                  }

                  return renderBlock(block, idx, prevBlock);
                })}

                {/* 🆕 AI思考指示器 */}
                {isAIThinking && (
                  <div className="msg-item">
                    <div className="msg-row">
                      <div className="msg-icon-wrapper">
                        {/* 🔥 极简头像 + 加载动画 */}
                        <SmartAvatar who="ai" isThinking={true} />
                      </div>
                      <div className="msg-text-wrapper">
                        {/* 🔥 保留原有的思考动画，但隐藏其头像 */}
                        <div className="thinking-wrapper">
                          <ConcordThinking
                            stage={thinkingStage}
                            style="claude"
                            showAvatar={false} // 如果组件支持这个属性
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div ref={messagesEndRef} />
              </div>

              <div className="ai-textarea-wrapper">
                {/* 输入框 */}
                <textarea
                  className="ai-textarea"
                  rows={1}
                  placeholder={
                    isSmartPlanActive
                      ? "Ask anything or say '5 days in Montreal'..."
                      : "询问行程问题或说'修改第X天'来调整行程..."
                  }
                  value={inputText}
                  onChange={(e) => setInputText(e.target.value)}
                  onKeyDown={handleKeyDown}
                  disabled={isProcessing || isAIThinking}
                />

                {/* 发送按钮 */}
                <button
                  className={`ai-send-icon-cute ${
                    isProcessing || isAIThinking ? "loading" : ""
                  }`}
                  onClick={handleSend}
                  disabled={isProcessing || isAIThinking}
                  title="Send message"
                >
                  {isProcessing || isAIThinking ? (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    <i className="bi bi-send-fill"></i>
                  )}
                </button>

                {/* 🆕 智能提示 - 就在这里！ */}
                {checkIfContainsDateInfo(inputText) && inputText.length > 5 && (
                  <div
                    className="smart-hint"
                    style={{
                      fontSize: "12px",
                      color: "#28a745",
                      marginTop: "5px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <i className="bi bi-lightbulb-fill"></i>
                    <span>
                      Date information detected, I'll generate your itinerary
                      automatically!
                    </span>
                  </div>
                )}
              </div>
            </>
          )}
        </Col>

        {/* ===== Right Side Panel ===== */}


        <Col
          xs={12}
          sm={5}
          md={5}
          lg={5}
          xl={5}
          className="side-panel border-start p-0"
        >
          {currentView === "explore" ||
          currentView === "mytrip" ||
          currentView === "saved" ||
          mapExpanded ? (
            <div className="expanded-map-wrapper">
              <div className="map-overlay-title">
                {currentView === "explore" ? (
                  <>
                    Selected Locations Map
                    {selectedExploreLocations.length > 0 && (
                      <small className="ms-2 text-muted">
                        ({selectedExploreLocations.length} selected)
                      </small>
                    )}
                  </>
                ) : currentView === "mytrip" ? (
                  <>
                    My Trip Map
                    {myTripItems.length > 0 && (
                      <small className="ms-2 text-muted">
                        ({myTripItems.length} items)
                      </small>
                    )}
                  </>
                ) : currentView === "saved" ? (
                  <>
                    Saved Locations Map
                    {favorites.length > 0 && (
                      <small className="ms-2 text-muted">
                        ({favorites.length} saved)
                      </small>
                    )}
                  </>
                ) : (
                  "Itinerary Map"
                )}
              </div>
              <div
                style={{
                  position: "absolute",
                  top: 40,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  maxHeight: isIPad ? "calc(100vh - 120px)" : "none",
                  overflow: isIPad ? "auto" : "visible",
                }}
              >
                {isMountedRef.current && (
                  <AdvancedAnimatedMap
                    locations={getMapLocations()}
                    itinerary={currentView === "chat" ? itinerary : []}
                    onMarkerClick={(data, name, number) => {
                      console.log("🗺️ Map marker clicked:", {
                        data,
                        name,
                        number,
                      });
                    }}
                  />
                )}
              </div>
            </div>
          ) : (
            <>
              {/* 🆕 新的推荐面板 - 替换原来的静态内容 */}
              <RecommendationPanel
                location="Montreal"
                onLocationSelect={handleExploreLocationSelect}
                onAddToFavorites={handleAddToFavorites}
                onAddToMyTrip={handleAddToMyTrip}
                favorites={favorites}
              />

              {/* 🗺️ 底部小地图 - 可选 */}
              {validLocations.length > 0 && (
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: isIPad ? "150px" : "200px",
                    borderTop: "1px solid #e0e0e0",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: 8,
                      left: 50,
                      transform: "translateX(-50%)",
                      background: "rgba(255,255,255,0.9)",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: "600",
                      zIndex: 1000,
                    }}
                  >
                    Preview Map
                  </div>
                  {isMountedRef.current && (
                    <AdvancedAnimatedMap
                      locations={getMapLocations()}
                      itinerary={itinerary}
                      onMarkerClick={(data, name, number) => {
                        console.log("🗺️ Preview map marker clicked:", {
                          data,
                          name,
                          number,
                        });
                        // 可以选择展开到全屏地图
                        setMapExpanded(true);
                      }}
                    />
                  )}
                </div>
              )}
            </>
          )}
        </Col>

        
      </Row>

      {isMobile && (
        <button className="mobile-fab" onClick={handleNewChat}>
          <i className="bi bi-plus-lg"></i>
        </button>
      )}

      <PlaceDetailModal
        show={showPlaceModal}
        onHide={handleCloseModal}
        placeData={selectedPlaceForModal?.data}
        placeName={selectedPlaceForModal?.name}
      />

      <TravelPreferenceModal
        show={showPreferenceModal}
        onHide={() => setShowPreferenceModal(false)}
        onConfirm={handlePreferenceConfirm}
        initialPreferences={travelPreferences}
      />
    </Container>
  );
};

export default ChatPage;
